import { styled, Typography } from "@mui/material"

export const ErrorText = styled(Typography)({
  fontSize: 14,
  color: "red"
})
